// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-y"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 5L16 7.3374C16 7.44308 15.9665 7.54603 15.9044 7.63149L12 13M8 5L8 7.33741C8 7.44308 8.03348 7.54603 8.09563 7.63149L12 13M12 13V19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersYIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-y',
    ref,
    icon: element,
  },
));

LettersYIcon.displayName = 'LettersYIcon';

export default LettersYIcon;
